import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Activity, FileText, CheckSquare, AlertTriangle } from 'lucide-react';
const deliverables = [{
  icon: BookOpen,
  title: 'Guía Paso a Paso',
  desc: 'El protocolo diario para desbloquear desde tu raíz hasta tu corona.'
}, {
  icon: Activity,
  title: 'Ejercicios MSS',
  desc: 'Instrucciones precisas de movimiento y respiración térmica.'
}, {
  icon: FileText,
  title: 'Hojas de Acción Diaria',
  desc: 'Worksheets para identificar y extraer tus mentiras mentales.'
}, {
  icon: CheckSquare,
  title: 'Checklist de Micro-Acciones',
  desc: 'Tareas de 5 minutos para mantener el flujo energético.'
}, {
  icon: AlertTriangle,
  title: 'Guía de Emergencia',
  desc: 'Qué hacer cuando el sobrepensar ataca de golpe.'
}];
export function DeliverablesSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-zinc-900/20" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16" data-id="element-18">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-19">
          {deliverables.map((item, i) => <FadeIn key={i} delay={0.1 * i} className={`glass-panel p-8 rounded-2xl flex flex-col items-start ${i === 3 ? 'md:col-span-1 lg:col-start-2' : ''} ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-20">
              <div className="p-3 bg-zinc-800/50 rounded-xl mb-6" data-id="element-21">
                <item.icon className="w-6 h-6 text-zinc-300" data-id="element-22" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-23">{item.title}</h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-24">{item.desc}</p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}